/**
 * 图形插入菜单：顶部工具条 Dropdown 共用
 */
import { useCallback, type ComponentType } from 'react';
import {
  IconMinus,
  IconSquare,
  IconCircle,
  IconTriangle,
} from '@tabler/icons-react';
import { useCanvas } from '@/components/canvas/designer/shell/CanvasContext';
import type { ShapeInsertKind } from '@/components/canvas/elements/shape/toolbar/shapeInsertKinds';

export type ShapeInsertId = ShapeInsertKind;

export function ShapeHeartIcon({ className = 'size-4 shrink-0' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={2}>
      <path d="M12 21C12 21 3 14.5 3 8.5a4.5 4.5 0 0 1 9-0.5 4.5 4.5 0 0 1 9 0.5C21 14.5 12 21 12 21Z" />
    </svg>
  );
}

export function ShapePolygonIcon({ className = 'size-4 shrink-0' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={2}>
      <polygon points="12,2 20,7 20,17 12,22 4,17 4,7" />
    </svg>
  );
}

export function ShapeStarIcon({ className = 'size-4 shrink-0' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={2}>
      <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
    </svg>
  );
}

export const SHAPE_INSERT_MENU_ITEMS: {
  id: ShapeInsertId;
  title: string;
  Icon: ComponentType<{ className?: string; stroke?: number }>;
}[] = [
  { id: 'line', title: '直线', Icon: IconMinus },
  { id: 'rect', title: '矩形', Icon: IconSquare },
  { id: 'circle', title: '圆形', Icon: IconCircle },
  { id: 'triangle', title: '三角形', Icon: IconTriangle },
  { id: 'polygon', title: '多边形', Icon: ShapePolygonIcon },
  { id: 'heart', title: '心形', Icon: ShapeHeartIcon },
  { id: 'star', title: '星形', Icon: ShapeStarIcon },
];

export function useShapeDrawMode() {
  const { shapeDrawKind, setShapeDrawKind, setTextDrawMode, setTableDrawMode } = useCanvas();

  return useCallback(
    (id: ShapeInsertId | string) => {
      setTextDrawMode(null);
      setTableDrawMode(false);
      const kind = id as ShapeInsertKind;
      setShapeDrawKind(shapeDrawKind === kind ? null : kind);
    },
    [shapeDrawKind, setShapeDrawKind, setTextDrawMode, setTableDrawMode],
  );
}
